import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class DptPhotographicRecordForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		photoRecords: Joi.array().min(1).required().label('Photo Records'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.photoRecords);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 16,
					multiple: true,
					name: 'photoRecords',
					accept: 'image/*,application/pdf',
					label: 'Photo Records',
					sublabel: 'Upload photos showing penetrant applied',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData = { photoRecords: [] };
export default DptPhotographicRecordForm;
